import { useNavigate, useRouterState } from '@tanstack/react-router'
import { useRef } from 'react'
import { Screen } from '@/patterns/screen'
import { SectionTabs } from '@/patterns/section-tabs'
import ceremonyIllustration from './assets/ceremony.svg'
import { CeremonyBasicsSheet } from './basics-sheet'
import { CeremonyMaterialsPage } from './materials'
import { CeremonyPeople, CeremonyPlanB, CeremonyScenario, CeremonySummary } from './overview'
import { CeremonyPeoplePage } from './people'
import { CeremonyPlacePage } from './place'
import { CeremonyPrompts, CeremonyTasks } from './preparations'
import { CeremonyScenarioPage } from './scenario'

export function CeremonyScreen() {
  const navigate = useNavigate()
  const editingBasics = useRouterState({
    select: (state) => state.location.pathname === '/ceremony/details',
  })
  const viewingScenario = useRouterState({
    select: (state) => state.location.pathname.startsWith('/ceremony/scenario'),
  })
  const viewingPeople = useRouterState({
    select: (state) => state.location.pathname.startsWith('/ceremony/people'),
  })
  const viewingPlace = useRouterState({
    select: (state) => state.location.pathname.startsWith('/ceremony/place'),
  })
  const viewingMaterials = useRouterState({
    select: (state) => state.location.pathname.startsWith('/ceremony/materials'),
  })
  const editButton = useRef<HTMLButtonElement>(null)
  const closeBasics = () => {
    void navigate({ to: '/ceremony' })
    requestAnimationFrame(() => editButton.current?.focus({ preventScroll: true }))
  }
  return (
    <Screen
      eyebrow="Plánovač"
      title="Obřad"
      description="Váš společný okamžik. A všechno, co k němu patří."
      illustration={
        <img src={ceremonyIllustration} alt="" width={200} height={128} className="h-auto w-full" />
      }
      tabs={
        <SectionTabs
          label="Stránky obřadu"
          active={
            viewingScenario
              ? '/ceremony/scenario'
              : viewingPeople
                ? '/ceremony/people'
                : viewingPlace
                  ? '/ceremony/place'
                  : viewingMaterials
                    ? '/ceremony/materials'
                    : '/ceremony'
          }
          tabs={[
            { to: '/ceremony', label: 'Přehled' },
            { to: '/ceremony/scenario', label: 'Scénář' },
            { to: '/ceremony/people', label: 'Lidé a role' },
            { to: '/ceremony/place', label: 'Místo a příprava' },
            { to: '/ceremony/materials', label: 'Podklady' },
          ]}
        />
      }
    >
      {viewingScenario ? (
        <CeremonyScenarioPage />
      ) : viewingPeople ? (
        <CeremonyPeoplePage />
      ) : viewingPlace ? (
        <CeremonyPlacePage />
      ) : viewingMaterials ? (
        <CeremonyMaterialsPage />
      ) : (
        <>
          <CeremonySummary
            onEdit={() => void navigate({ to: '/ceremony/details' })}
            editButton={editButton}
          />
          <div className="grid items-start gap-6 xl:grid-cols-[minmax(0,1.35fr)_minmax(0,1fr)]">
            <CeremonyScenario />
            <div className="space-y-6">
              <CeremonyPeople />
              <CeremonyPlanB />
            </div>
          </div>
          <CeremonyPrompts />
          <CeremonyTasks />
        </>
      )}
      {editingBasics ? <CeremonyBasicsSheet onClose={closeBasics} /> : null}
    </Screen>
  )
}
